import { GET_USER_REDEEMS, GET_USER_REDEEMS_FAIL, GET_USER_REDEEMS_SUCCESS, GET_USER_REFERRAL, GET_USER_REFERRAL_FAIL, GET_USER_REFERRAL_SUCCESS, SEND_REFERRAL_MAIL, SEND_REFERRAL_MAIL_FAIL, SEND_REFERRAL_MAIL_SUCCESS } from "./actionType";

const INIT_STATE = {
    error: "",
    loading: false,
    referrals: [],
    redeems: [],
};

const Referrals = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_USER_REFERRAL:
        case SEND_REFERRAL_MAIL:
        case GET_USER_REDEEMS:
            return {
                ...state,
                loading: true,
            };


        case GET_USER_REFERRAL_FAIL:
        case SEND_REFERRAL_MAIL_FAIL:
        case GET_USER_REDEEMS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            };


        case GET_USER_REFERRAL_SUCCESS:
            return {
                ...state,
                loading: false,
                referrals: action.payload.data || [],
            };
        case SEND_REFERRAL_MAIL_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case GET_USER_REDEEMS_SUCCESS:
            return {
                ...state,
                loading: false,
                redeems: action.payload.data || [],
            };

        default:
            return state;
    };
}

export default Referrals;